export default {
  'config': {
    'form_group': 'Group',
    'form_select_group': 'Select Group',
    'form_type': 'Type',
    'form_select_type': 'Select type',
    'form_title': 'Title',
    'form_enter_title': 'enter title',
    'form_name': 'Name',
    'form_enter_name': 'enter name',
    'form_options': 'Options',
    'form_enter_options': 'enter options',
    'form_options_value': 'Value',
    'form_enter_options_value': 'enter options value',
    'form_description': 'Desc',
    'form_enter_description': 'enter desc',
    'form_listorder': 'Sort',
    'form_enter_listorder': 'enter sort',
    'form_group_none': 'None group',
    'form_type_text': 'text',
    'form_type_textarea': 'textarea',
    'form_type_array': 'array',
    'form_type_number': 'number',
    'form_type_radio': 'radio',
    'form_type_checkbox': 'checkbox',
    'form_type_select': 'select',
    'form_type_switch': 'switch',
    'form_type_image': 'image',
    'form_type_rate': 'rate',
    'form_type_color': 'color',
    'form_type_slider': 'slider',
    'form_type_time': 'time',
    'form_type_date': 'date',
    'form_type_range_time': 'range time',
    'form_type_range_date': 'range date',
    'form_show': 'Show',
    'form_show_enable': 'enable',
    'form_show_disable': 'disable',
    'form_status': 'Status',
    'form_status_enable': 'enable',
    'form_status_disable': 'disable',
    'form_save': 'Save',
    'form_create_success': 'create success',
    'form_update_success': 'update success',
    
    'rules_type_required': 'type required',
    'rules_title_required': 'title required',
    'rules_name_required': 'name required',
    'rules_listorder_required': 'sort required',

    'search_title': 'Config Option',
    'search_searchword': 'enter keywords',
    'search_group': 'Group',
    'search_group_none': 'none group',
    'search_status': 'Status',
    'search_status_enable': 'Enable',
    'search_status_disable': 'Disable',
    'search_sort_asc': 'Asc',
    'search_sort_desc': 'Desc',
    'search_btn': 'Search',
    'search_create_config': 'Add',
    
    'table_name': 'Name',
    'table_title': 'Title',
    'table_type': 'Type',
    'table_group': 'Group',
    'table_listorder': 'Sort',
    'table_create_time': 'CreateTime',
    'table_status': 'Status',
    'table_actions': 'Actions',
    'table_detail': 'Detail',
    'table_update': 'Update',
    'table_delete': 'Delete',
    'table_listorder_success': 'Update sort success',
    
    'dialog_detail': 'Config detail',
    'dialog_create': 'Config create',
    'dialog_update': 'Config update',
    
    'detail_id': 'ID',
    'detail_group': 'Group',
    'detail_type': 'Type',
    'detail_title': 'Title',
    'detail_name': 'Name',
    'detail_options': 'Options',
    'detail_options_value': 'Value',
    'detail_description': 'Desc',
    'detail_listorder': 'Sort',
    'detail_show': 'Show',
    'detail_status': 'Status',
    'detail_update_time': 'UpdateTime',
    'detail_create_time': 'CreateTime',
    
    'enable_success': 'enable success',
    'disable_success': 'disable success',
    'confirm_delete': 'confirm delete the config?',
    'confirm_delete_success': 'delete the config success',

    'setting_title': 'Web Setting',
    'setting_save': 'Save',
    'setting_loading': 'loading..',
    'setting_save_success': 'Save success',
  },
}
